import React from 'react';
import Styled from 'styled';

import Avatar from './avatar/avatar';
import Likes from './likes/likes';
import LastLogin from './last-login/last-login';
import RegistrationDate from './registration-date/registration-date';

import { UserFragment } from './user.graphql';
import defaultStyles from './user.scss';

export interface Props extends UserFragment {
    styles?: typeof defaultStyles;
}

class User extends React.PureComponent<Props> {
    render() {
        const { styles, ...rest } = this.props;

        return (
            <tr className={styles!.row}>
                <td className={styles!.cell}>
                    <Avatar {...rest} />
                </td>
                <td className={styles!.cell}>
                    <Likes {...rest} />
                </td>
                <td className={styles!.cell}>{this.props.forumMessagesCount}</td>
                <td className={styles!.cell}>
                    <LastLogin {...rest} />
                </td>
                <td className={styles!.cell}>
                    <RegistrationDate {...rest} />
                </td>
            </tr>
        );
    }
}

export default Styled(defaultStyles)(User);
